import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryReceivingDetailReport'
import Component from 'components/Reports/InventoryReceivingDetailReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryReceivingDetailReport })(Component)
